const calculateTransformY = (element, translateY = 0) => {
  if (!element) return translateY;

  const context = element.ownerDocument.defaultView;
  if (!context) return translateY;

  const { getComputedStyle, WebKitCSSMatrix } = context;
  const { transform } = getComputedStyle(element);
  const { m42: topOffset } = new WebKitCSSMatrix(transform);
  return calculateTransformY(element.parentElement, translateY + topOffset);
};

const getComputedOffset = (element, offset = 0) => {
  if (element.offsetParent)
    return getComputedOffset(element.offsetParent, offset + element.offsetTop);

  return offset + element.offsetTop;
};

const getElementOffset = (element) => getComputedOffset(element) + calculateTransformY(element);

export default getElementOffset;
